import { render } from "./AuditModificationsTelephone.vue?vue&type=template&id=38b57ab7&scoped=true"
import script from "./AuditModificationsTelephone.vue?vue&type=script&lang=js"
export * from "./AuditModificationsTelephone.vue?vue&type=script&lang=js"

import "./AuditModificationsTelephone.vue?vue&type=style&index=0&id=38b57ab7&scoped=true&lang=css"

import exportComponent from "/data/opt/gitlab-runner/working-directory/podman-stable_v4.8.1/corpo/crp-cardex-webapp/src/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b57ab7"]])

export default __exports__